export default __webpack_public_path__ + "static/thumb_lg_01-1589685709f0a85f56f2caf557b4ce86.png";